import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'

import { isMobile } from '@flowwai-frontend/shared/utils/web'

import { REACT_LOADING_DURATION } from '../../Loader/constants'

import MobileTaskDetailedViewLoader from './MobileTaskDetailedViewLoader'
import {
   TaskDetailedViewWrapper,
   TaskTitleUpdateActionLoadingWrapper,
   TaskIdAndActionsLoadingWrapper,
   HeaderLoadingWrapper,
   TaskIdAndCopyLoaderWrapper,
   TaskDescriptionLoadingWrapper,
   TaskFieldsLoadingWrapper,
   FieldLoadingWrapper
} from './styledComponents'

class TaskDetailedViewLoader extends React.Component {
   numberOfTaskFields = 9
   renderHeaderLoader = () => (
      <HeaderLoadingWrapper>
         <TaskTitleUpdateActionLoadingWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               height={30}
               style={{ flexGrow: 1 }}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={80}
               height={24}
               style={{ marginLeft: 10 }}
            />
         </TaskTitleUpdateActionLoadingWrapper>
         <TaskIdAndActionsLoadingWrapper>
            <TaskIdAndCopyLoaderWrapper>
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={100}
                  height={24}
               />
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={80}
                  height={15}
                  style={{ marginLeft: '1rem' }}
               />
            </TaskIdAndCopyLoaderWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               count={4}
               width={100}
               height={30}
               style={{ margin: '0px 5px' }}
            />
         </TaskIdAndActionsLoadingWrapper>
      </HeaderLoadingWrapper>
   )
   renderTaskDescriptionLoader = () => (
      <TaskDescriptionLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={100}
            height={14}
            style={{ marginBottom: 12 }}
         />
         <Skeleton duration={REACT_LOADING_DURATION} height={80} />
      </TaskDescriptionLoadingWrapper>
   )
   renderTaskFieldsLoader = () => (
      <TaskFieldsLoadingWrapper>
         {Array.from(Array(this.numberOfTaskFields).keys()).map(index => (
            <FieldLoadingWrapper key={index}>
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={100}
                  height={14}
                  style={{ marginBottom: 12 }}
               />
               <Skeleton
                  duration={REACT_LOADING_DURATION}
                  width={320}
                  height={36}
               />
            </FieldLoadingWrapper>
         ))}
      </TaskFieldsLoadingWrapper>
   )

   render() {
      const {
         renderHeaderLoader: RenderHeaderLoader,
         renderTaskDescriptionLoader: RenderTaskDescriptionLoader,
         renderTaskFieldsLoader: RenderTaskFieldsLoader
      } = this
      if (isMobile()) {
         return <MobileTaskDetailedViewLoader />
      }

      return (
         <TaskDetailedViewWrapper>
            <RenderHeaderLoader />
            <RenderTaskDescriptionLoader />
            <RenderTaskFieldsLoader />
         </TaskDetailedViewWrapper>
      )
   }
}

export default observer(TaskDetailedViewLoader)
